module.exports = __webpack_public_path__ + "3f359060b4010f9ca2b22f741e82fb6f.MP3";